var Backbone, EmailFormUSLocationListRowView, EmailFormUSLocationListView, EmailFormUSLocationSelectPaginationView, SupportLocationListTemplate,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportLocationListTemplate = require('../../../../location_list_view.html.mustache');

EmailFormUSLocationListRowView = require('./location_list_row_view');

EmailFormUSLocationSelectPaginationView = require("./location_select_pagination");

Backbone = require('backbone');

Backbone.$ = $;

EmailFormUSLocationListView = (function(superClass) {
  extend(EmailFormUSLocationListView, superClass);

  function EmailFormUSLocationListView() {
    return EmailFormUSLocationListView.__super__.constructor.apply(this, arguments);
  }

  EmailFormUSLocationListView.prototype.id = 'popupContent';

  EmailFormUSLocationListView.prototype.initialize = function(options) {
    this.options = options || {};
    _.bindAll.apply(_, [this].concat(_.functions(this)));
    this.I18nScope = 'modules.support';
    this.template = SupportLocationListTemplate;
    this.locations = Groupon.Support.currentOrder.dealOption.redemptionLocations;
    this.noOfItemsPerPage = 15;
    this.startIndex = 0;
    this.render();
    this.renderLocations();
    this.paginationView = new EmailFormUSLocationSelectPaginationView({
      paginationElement: $(this.el).find('div#locationPagination'),
      itemsPerPage: this.noOfItemsPerPage,
      totalNoOfItems: this.locations.length,
      callback: this.paginationClickHandler
    });
    this.renderPagination();
    this.popup = $("#popup");
    GIG.Modal.open({
      el: this.popup,
      closeOnBgClick: true,
      closeOnEscKey: true
    });
    return this.popup.html(this.el);
  };

  EmailFormUSLocationListView.prototype.render = function() {
    return this.renderHeaderAndFooter();
  };

  EmailFormUSLocationListView.prototype.renderPagination = function() {
    return this.paginationView.render();
  };

  EmailFormUSLocationListView.prototype.renderHeaderAndFooter = function() {
    return this.$el.html(toHtml(this.template, {}, this.I18nScope));
  };

  EmailFormUSLocationListView.prototype.renderLocations = function() {
    var elementsPushedIntoRow, endIndex, i, index, locationsTable, obj, ref, ref1, results, row, rowElements, startIndex;
    locationsTable = $(this.el).find('table#locationsTable');
    locationsTable.empty();
    startIndex = this.startIndex * this.noOfItemsPerPage;
    endIndex = startIndex + this.noOfItemsPerPage - 1;
    if (endIndex > (this.locations.length - 1)) {
      endIndex = this.locations.length - 1;
    }
    rowElements = [];
    elementsPushedIntoRow = 0;
    results = [];
    for (index = i = ref = startIndex, ref1 = endIndex; i <= ref1; index = i += 1) {
      obj = this.locations[index];
      obj.id = index;
      rowElements[elementsPushedIntoRow] = obj;
      elementsPushedIntoRow += 1;
      if (elementsPushedIntoRow === 3 || index === endIndex) {
        row = new EmailFormUSLocationListRowView({
          elements: rowElements
        });
        locationsTable.append(row.el);
        row.render();
        elementsPushedIntoRow = 0;
        results.push(rowElements = []);
      } else {
        results.push(void 0);
      }
    }
    return results;
  };

  EmailFormUSLocationListView.prototype.paginationClickHandler = function(newPageIndex, paginationContainer) {
    this.startIndex = newPageIndex;
    this.renderLocations();
    return false;
  };

  EmailFormUSLocationListView.prototype.finishChoosingLocations = function() {
    var i, len, location, ref;
    GIG.Modal.close();
    ref = Groupon.Support.currentOrder.dealOption.redemptionLocations;
    for (i = 0, len = ref.length; i < len; i++) {
      location = ref[i];
      location.isSelected = location.isMarked;
    }
    this.options.cb.call();
    return false;
  };

  EmailFormUSLocationListView.prototype.cancelChoosingLocations = function() {
    GIG.Modal.close();
    return false;
  };

  EmailFormUSLocationListView.prototype.events = {
    "click #btnsubmit": "finishChoosingLocations",
    "click #cancelLocationSelect": "cancelChoosingLocations",
    'click .close-modal': "cancelChoosingLocations"
  };

  return EmailFormUSLocationListView;

})(Backbone.View);

module.exports = EmailFormUSLocationListView;

//# sourceMappingURL=data:application/json;base64,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
